var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('b-button',{attrs:{"variant":"danger"},on:{"click":_vm.makeDelete}},[_vm._v("\n  "+_vm._s(_vm.$t('myCertificates.toolbar.delete'))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }